import ArticleIcon from '@mui/icons-material/Article';
import { Card, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { useParams } from 'react-router';

export const IncludedTranscripts = ({ item }) => {
  const { id } = useParams();
  // const { data: interview } = useSingleInterview(id);

  // Get display name for a transcript - uses name if available, otherwise "Transcript N"
  // const getTranscriptDisplayName = useCallback(
  //   (transcriptId) => {
  //     if (!interview?.transcripts) return `Transcript`;
  //     const transcripts = interview.transcripts;
  //     const transcript = transcripts.find((t) => t.id === transcriptId);
  //     if (transcript?.name) return transcript.name;
  //     const index = transcripts.findIndex((t) => t.id === transcriptId);
  //     return index !== -1 ? `Transcript ${index + 1}` : `Transcript`;
  //   },
  //   [interview?.transcripts],
  // );

  if (!item?.qualitative_items_included?.length > 0) return null;

  return (
    <Card variant="outlined" sx={{ mt: 3 }}>
      <List dense disablePadding>
        <ListItem disableGutters>
          <ListItemIcon sx={{ minWidth: 30 }}>
            <ArticleIcon color="action" />
          </ListItemIcon>
          <ListItemText
            primary={`Included Transcripts (${item.qualitative_items_included.length})`}
            primaryTypographyProps={{ variant: 'h6', fontWeight: 'bold' }}
          />
        </ListItem>
        {item.qualitative_items_included.map((transcript) => (
          <ListItem key={transcript?.id} disableGutters>
            <ListItemText
              primary={
                <a
                  href={`/interview/${id}/transcripts/${transcript?.id}`}
                  style={{ textDecoration: 'none', color: 'inherit' }}
                  target="_blank"
                  rel="noreferrer"
                >
                  {transcript?.name}
                </a>
              }
              primaryTypographyProps={{ variant: 'body2' }}
            />
          </ListItem>
        ))}
      </List>
    </Card>
  );
};
